import { z } from 'zod';
import {
  isValidCEP,
  isValidCPF,
  isValidDate,
  isValidPhone,
} from '@/utils/form-validators';

const requiredMessage = 'Campo obrigatório';

const requiredStringField = z
  .string({ message: requiredMessage })
  .min(1, requiredMessage);

export const registrationSchema = z
  .object({
    name: requiredStringField,
    cpf: requiredStringField.refine((cpf) => isValidCPF(cpf), {
      message: 'CPF inválido',
    }),
    birthDate: requiredStringField.refine((date) => isValidDate(date), {
      message: 'Formato aceito: dd/mm/aaaa',
    }),
    countryCode: requiredStringField,
    phone: requiredStringField.refine((phone) => isValidPhone(phone), {
      message: 'Formato aceito: (00) 00000-0000 ou (00) 0000-0000',
    }),
    email: z.string().email('Email inválido'),
    cep: requiredStringField.refine((cep) => isValidCEP(cep), {
      message: 'Formato aceito: 00000-000',
    }),
    city: requiredStringField,
    state: requiredStringField,
    street: requiredStringField,
    neighborhood: requiredStringField,
    no_number: z.boolean().default(false),
    number: z.string().optional(),
    complement: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.no_number && !data.number) {
      ctx.addIssue({
        path: ['number'],
        code: 'custom',
        message: 'Número é obrigatório',
      });
    }
  });

export type RegistrationFormData = z.infer<typeof registrationSchema>;
